import React from 'react';
import {Button} from '@material-ui/core';
import {NumberInput} from '@treez-ui/core/forms';

interface Props {
    numItems: number;
    onChange: (page: number, pageSize: number) => void;
    pageSize: number;
}

const JumpToPage = (props: Props) => {
    const {numItems, onChange: handlePaginationChange, pageSize} = props;

    const [currentPage, setCurrentPage] = React.useState<string>('1');

    const handleOnChange = (value: string) => {
        setCurrentPage(value);
    };

    const submitChange = () => {
        const pageNumber = Number.parseInt(currentPage);
        if (isValidPageNumber(pageNumber)) {
            handlePaginationChange(pageNumber - 1, pageSize);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            submitChange();
        }
    };

    const isValidPageNumber = (pageNumber: number) => {
        return Number.isInteger(pageNumber) && pageNumber > 0 && pageNumber <= getTotalPages();
    };

    const getTotalPages = () => {
        const pages = numItems / pageSize;

        if (Number.isNaN(pages)) {
            return 1;
        }

        return Math.ceil(pages);
    };

    return (
        <div className="jump-to-page-container">
            <div className="jump-to-page-text">Go to page</div>
            <NumberInput
                className="jump-to-page-input"
                onChange={handleOnChange}
                value={currentPage}
                onKeyPress={handleKeyDown}
            />
            <div className="jump-to-page-text">/ {getTotalPages()}</div>
            <Button className="jump-to-page-button" variant="contained" onClick={submitChange}>
                Go
            </Button>
        </div>
    );
};

export default JumpToPage;
